// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageBannerForm-space1-nbLnZ {
	margin-bottom: 6px !important;
}

.ImageBannerForm-space2-nGyTn {
	margin-bottom: 12px !important;
}

.ImageBannerForm-space3-fpokL {
	margin-bottom: 18px !important;
}

.ImageBannerForm-space4-lTtz5 {
	margin-bottom: 24px !important;
}

.ImageBannerForm-space5-HD70B {
	margin-bottom: 30px !important;
}

.ImageBannerForm-space6-W25IV {
	margin-bottom: 36px !important;
}

.ImageBannerForm-space7-QsFAV {
	margin-bottom: 42px !important;
}

.ImageBannerForm-space8-RNPLt {
	margin-bottom: 48px !important;
}

.ImageBannerForm-spaceTop1-At7ih {
	margin-top: 6px !important;
}

.ImageBannerForm-spaceTop2-qCmq3 {
	margin-top: 12px !important;
}

.ImageBannerForm-spaceTop3-ZbV_O {
	margin-top: 18px !important;
}

.ImageBannerForm-spaceTop4-clvwP {
	margin-top: 24px !important;
}

.ImageBannerForm-spaceTop5-L06eD {
	margin-top: 30px !important;
}

.ImageBannerForm-spaceTop6-RK7H1 {
	margin-top: 36px !important;
}

.ImageBannerForm-spaceTop7-dTYD8 {
	margin-top: 42px !important;
}

.ImageBannerForm-spaceTop8-dHHeC {
	margin-top: 48px !important;
}

.ImageBannerForm-noMargin-yw8sQ {
	margin: 0px !important;
}

.ImageBannerForm-padding1-iCaDD {
	padding-bottom: 6px !important;
}

.ImageBannerForm-padding2-NnwFw {
	padding-bottom: 12px !important;
}

.ImageBannerForm-padding3-VKS0e {
	padding-bottom: 18px !important;
}

.ImageBannerForm-padding4-GSWiq {
	padding-bottom: 24px !important;
}

.ImageBannerForm-padding5-i0j5f {
	padding-bottom: 30px !important;
}

.ImageBannerForm-padding6-FkZt8 {
	padding-bottom: 36px !important;
}

.ImageBannerForm-padding7-yRvG7 {
	padding-bottom: 42px !important;
}

.ImageBannerForm-paddingTop1-Qzb8H {
	padding-top: 6px !important;
}

.ImageBannerForm-paddingTop2-kQplE {
	padding-top: 12px !important;
}

.ImageBannerForm-paddingTop3-r3EG1 {
	padding-top: 18px !important;
}

.ImageBannerForm-paddingTop4-CE3pq {
	padding-top: 24px !important;
}

.ImageBannerForm-paddingTop5-IxQHh {
	padding-top: 30px !important;
}

.ImageBannerForm-paddingTop6-k4Eba {
	padding-top: 36px !important;
}

.ImageBannerForm-paddingTop7-Ul4Y_ {
	padding-top: 42px !important;
}

.ImageBannerForm-noPadding-fMeyI {
	padding: 0px !important;
}

.ImageBannerForm-spaceMarginBottom0-jQ_Al {
	margin-bottom: 0;
}

.ImageBannerForm-textBold-Oe9lE {
	font-weight: 500 !important;
}

.ImageBannerForm-textBolder-c56At {
	font-weight: 700 !important;
}

.ImageBannerForm-textNormal-w1FG_ {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ImageBannerForm-textDarkBlue-YoynR {
	color: rgb(20, 39, 94) !important;
}

.ImageBannerForm-textLightBlue-wmQOd {
	color: rgb(57, 87, 106) !important;
}

.ImageBannerForm-textLightSandleGreen-m4Czy {
	color: rgb(76, 86, 41) !important;
}

.ImageBannerForm-textLightBrown-b2_ZI {
	color: rgb(115, 79, 33) !important;
}

.ImageBannerForm-textMediumMaroon-oPc8W {
	color: rgb(87, 37, 51) !important;
}

.ImageBannerForm-textBrown-wc61O {
	color: rgb(160, 47, 24) !important;
}

.ImageBannerForm-textMaroon-NyV_k {
	color: rgb(155, 49, 67) !important;
}

.ImageBannerForm-textDarkBrown-Hx8al {
	color: rgb(83, 18, 16) !important;
}

.ImageBannerForm-textMediumBrown-FNiuI {
	color: rgb(142, 28, 10) !important;
}

.ImageBannerForm-textSkyBlue-XcmBT {
	color: rgb(37, 117, 141) !important;
}

.ImageBannerForm-textGray-TLe2Y {
	color: rgb(77, 65, 51) !important;
}

.ImageBannerForm-errorMessage-qOIbz {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ImageBannerForm-userText-V2B5v {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ImageBannerForm-panelHeader-LRW4z {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ImageBannerForm-exportSection-QzIDu {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ImageBannerForm-exportSectionGridSub-OA2BJ {
	grid-template-columns: 50% 49% !important;
}

.ImageBannerForm-exportText-kZMhk {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ImageBannerForm-exportLinkImg-AqTEu {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ImageBannerForm-exportImg-REnUb {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ImageBannerForm-linkBtn-Cpdji {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ImageBannerForm-table-BCPN3 {
	display: table;
}

.ImageBannerForm-tableRow-CUVwz {
	display: table-row;
}

.ImageBannerForm-tableCell-jXjw6 {
	display: table-cell;
	float: none;
}

.ImageBannerForm-formGroup-Akye2 {
	margin-bottom: 6px;
}

.ImageBannerForm-marginTop0-ObKd8 {
	margin-top: 0;
}

.ImageBannerForm-marginBottom20-jQ947 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ImageBannerForm-bannerImageBg-olQQK {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ImageBannerForm-bannerDelete-DOWOv {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ImageBannerForm-exportLink-thra_ {
	padding-top: 10px;
	padding-right: 10px;
}

.ImageBannerForm-seachContent-PTmws {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ImageBannerForm-marginBottom9-U3LqH {
	margin-bottom: 9px;
}

.ImageBannerForm-spaceTop52-uTalv {
	margin-top: 52px;
}

.ImageBannerForm-profileViewInner-FbcDu {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ImageBannerForm-profileViewMain-PH9CB {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ImageBannerForm-profileViewlabel-YGOJx {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ImageBannerForm-profileViewMainContent-xhC9b {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ImageBannerForm-reviewsFormStar-OGQyu {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ImageBannerForm-reviewsFormStar-OGQyu svg {
	cursor: pointer;
}

.ImageBannerForm-addLanguageText-zy956 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ImageBannerForm-exportSection-QzIDu {
		grid-template-columns: 100%;
	}

	.ImageBannerForm-spaceTop52-uTalv {
		margin-top: 18px;
	}

	.ImageBannerForm-exportText-kZMhk {
		float: none;
		margin-top: 12px;
	}

	.ImageBannerForm-exportSectionGridSub-OA2BJ {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ImageBannerForm-profileViewlabel-YGOJx {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ImageBannerForm-profileViewMainContent-xhC9b {
		width: 100%;
		text-align: center;
	}

	.ImageBannerForm-panelHeader-LRW4z {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ImageBannerForm-space1-nbLnZ`,
	"space2": `ImageBannerForm-space2-nGyTn`,
	"space3": `ImageBannerForm-space3-fpokL`,
	"space4": `ImageBannerForm-space4-lTtz5`,
	"space5": `ImageBannerForm-space5-HD70B`,
	"space6": `ImageBannerForm-space6-W25IV`,
	"space7": `ImageBannerForm-space7-QsFAV`,
	"space8": `ImageBannerForm-space8-RNPLt`,
	"spaceTop1": `ImageBannerForm-spaceTop1-At7ih`,
	"spaceTop2": `ImageBannerForm-spaceTop2-qCmq3`,
	"spaceTop3": `ImageBannerForm-spaceTop3-ZbV_O`,
	"spaceTop4": `ImageBannerForm-spaceTop4-clvwP`,
	"spaceTop5": `ImageBannerForm-spaceTop5-L06eD`,
	"spaceTop6": `ImageBannerForm-spaceTop6-RK7H1`,
	"spaceTop7": `ImageBannerForm-spaceTop7-dTYD8`,
	"spaceTop8": `ImageBannerForm-spaceTop8-dHHeC`,
	"noMargin": `ImageBannerForm-noMargin-yw8sQ`,
	"padding1": `ImageBannerForm-padding1-iCaDD`,
	"padding2": `ImageBannerForm-padding2-NnwFw`,
	"padding3": `ImageBannerForm-padding3-VKS0e`,
	"padding4": `ImageBannerForm-padding4-GSWiq`,
	"padding5": `ImageBannerForm-padding5-i0j5f`,
	"padding6": `ImageBannerForm-padding6-FkZt8`,
	"padding7": `ImageBannerForm-padding7-yRvG7`,
	"paddingTop1": `ImageBannerForm-paddingTop1-Qzb8H`,
	"paddingTop2": `ImageBannerForm-paddingTop2-kQplE`,
	"paddingTop3": `ImageBannerForm-paddingTop3-r3EG1`,
	"paddingTop4": `ImageBannerForm-paddingTop4-CE3pq`,
	"paddingTop5": `ImageBannerForm-paddingTop5-IxQHh`,
	"paddingTop6": `ImageBannerForm-paddingTop6-k4Eba`,
	"paddingTop7": `ImageBannerForm-paddingTop7-Ul4Y_`,
	"noPadding": `ImageBannerForm-noPadding-fMeyI`,
	"spaceMarginBottom0": `ImageBannerForm-spaceMarginBottom0-jQ_Al`,
	"textBold": `ImageBannerForm-textBold-Oe9lE`,
	"textBolder": `ImageBannerForm-textBolder-c56At`,
	"textNormal": `ImageBannerForm-textNormal-w1FG_`,
	"textDarkBlue": `ImageBannerForm-textDarkBlue-YoynR`,
	"textLightBlue": `ImageBannerForm-textLightBlue-wmQOd`,
	"textLightSandleGreen": `ImageBannerForm-textLightSandleGreen-m4Czy`,
	"textLightBrown": `ImageBannerForm-textLightBrown-b2_ZI`,
	"textMediumMaroon": `ImageBannerForm-textMediumMaroon-oPc8W`,
	"textBrown": `ImageBannerForm-textBrown-wc61O`,
	"textMaroon": `ImageBannerForm-textMaroon-NyV_k`,
	"textDarkBrown": `ImageBannerForm-textDarkBrown-Hx8al`,
	"textMediumBrown": `ImageBannerForm-textMediumBrown-FNiuI`,
	"textSkyBlue": `ImageBannerForm-textSkyBlue-XcmBT`,
	"textGray": `ImageBannerForm-textGray-TLe2Y`,
	"errorMessage": `ImageBannerForm-errorMessage-qOIbz`,
	"userText": `ImageBannerForm-userText-V2B5v`,
	"panelHeader": `ImageBannerForm-panelHeader-LRW4z`,
	"exportSection": `ImageBannerForm-exportSection-QzIDu`,
	"exportSectionGridSub": `ImageBannerForm-exportSectionGridSub-OA2BJ`,
	"exportText": `ImageBannerForm-exportText-kZMhk`,
	"exportLinkImg": `ImageBannerForm-exportLinkImg-AqTEu`,
	"exportImg": `ImageBannerForm-exportImg-REnUb`,
	"linkBtn": `ImageBannerForm-linkBtn-Cpdji`,
	"table": `ImageBannerForm-table-BCPN3`,
	"tableRow": `ImageBannerForm-tableRow-CUVwz`,
	"tableCell": `ImageBannerForm-tableCell-jXjw6`,
	"formGroup": `ImageBannerForm-formGroup-Akye2`,
	"marginTop0": `ImageBannerForm-marginTop0-ObKd8`,
	"marginBottom20": `ImageBannerForm-marginBottom20-jQ947`,
	"bannerImageBg": `ImageBannerForm-bannerImageBg-olQQK`,
	"bannerDelete": `ImageBannerForm-bannerDelete-DOWOv`,
	"exportLink": `ImageBannerForm-exportLink-thra_`,
	"seachContent": `ImageBannerForm-seachContent-PTmws`,
	"marginBottom9": `ImageBannerForm-marginBottom9-U3LqH`,
	"spaceTop52": `ImageBannerForm-spaceTop52-uTalv`,
	"profileViewInner": `ImageBannerForm-profileViewInner-FbcDu`,
	"profileViewMain": `ImageBannerForm-profileViewMain-PH9CB`,
	"profileViewlabel": `ImageBannerForm-profileViewlabel-YGOJx`,
	"profileViewMainContent": `ImageBannerForm-profileViewMainContent-xhC9b`,
	"reviewsFormStar": `ImageBannerForm-reviewsFormStar-OGQyu`,
	"addLanguageText": `ImageBannerForm-addLanguageText-zy956`
};
module.exports = ___CSS_LOADER_EXPORT___;
